import React from 'react';
import { InfoPanelTemplate } from 'themes/components';

function InfoPanel(props) {
	return <InfoPanelTemplate {...props} />;
}

export default InfoPanel;
